import script from "./DigitalAssistant.vue?vue&type=script&setup=true&lang=js"
export * from "./DigitalAssistant.vue?vue&type=script&setup=true&lang=js"

import "./DigitalAssistant.vue?vue&type=style&index=0&id=d71d5ada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d71d5ada"]])

export default __exports__